export default "__VITE_PUBLIC_ASSET__fc182c42__"